const firebaseConfig = {
   apiKey: "AIzaSyBLnW-C7xKsNzolZfcwfJEjbkwtCN5Aj6Y",
   authDomain: "edumodooo.firebaseapp.com",
   projectId: "edumodooo",
   storageBucket: "edumodooo.appspot.com",
   messagingSenderId: "819009004743",
   appId: "1:819009004743:web:6c0f5b491afc463d258ae2",
};

export default firebaseConfig;
